import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { SqlPoolTableDataset } from 'app/model/dataset/sql-pool-table.dataset';
import { SqlPool, ReferenceAdapter } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlPoolTableDataset),
    asynchronous: true,
    adapts: {
        ...tabularTypeDatasetAdapts,
        properties: {
            ...tabularTypeDatasetAdapts.properties,
            sqlPool: '*'
        }
    }
})
export class SqlPoolTableDatasetAdapter extends TabularTypeDatasetAdapter<SqlPoolTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SqlPoolTableDataset): Promise<Model.DatasetResource> {
        const resource = await this._toResourceInternal(dataset, Metamodel.modelFor(SqlPoolTableDataset).name);
        resource.properties.sqlPool = this._getSqlPoolReference(dataset.sqlPool);
        return resource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SqlPoolTableDataset): Promise<SqlPoolTableDataset> {
        const sqlDataset = await this._toModelInternal(modelDatasetResource, dataset, SqlPoolTableDataset.MODEL);

        if (modelDatasetResource.properties && modelDatasetResource.properties.sqlPool) {
            sqlDataset.sqlPool = ReferenceAdapter.toProxyModel<SqlPool>(Metamodel.modelFor(SqlPool), modelDatasetResource.properties.sqlPool, this.context);
        }
        return sqlDataset;
    }

    private _getSqlPoolReference(named: SqlPool): Model.ArtifactReference {
        if (!named) {
            return undefined;
        }
        return ReferenceAdapter.toResource(named, this.context) as Model.ArtifactReference;
    }
}
